import {Component, Input} from '@angular/core';
import {
  ColorProfile,
  colorProfiles,
  PROCESSING_STATUS_MAPPING,
  STATUS_MAPPING
} from "../../../constants/global-constants";

@Component({
  selector: 'status',
  templateUrl: './status.component.html',
  styleUrl: './status.component.scss'
})
export class StatusComponent {
  @Input() status: string = ''

  label: string
  bg_color: string
  text_color: string

  ngOnInit() {
    let mapping = STATUS_MAPPING[this.status] ? STATUS_MAPPING[this.status] : PROCESSING_STATUS_MAPPING[this.status]
    this.label = mapping.label;
    let color: ColorProfile = colorProfiles[mapping.profile]
    this.bg_color = color.bg_color
    this.text_color = color.text_color
  }
}
